import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
const NextButton = ({ onClickFn, text, enabled }) => {
    const { t } = useTranslation();
    return (_jsxs("button", Object.assign({ "data-testid": 'next-button', className: 'button--next', onClick: enabled ? onClickFn : undefined, disabled: !enabled }, { children: [t(text), _jsx(ArrowForwardRoundedIcon, { fontSize: "small" })] })));
};
export default NextButton;
